export var defaultLabelGetter = function defaultLabelGetter(item) {
  return item ? item.label : '';
};
export var defaultValeGetter = function defaultValeGetter(item) {
  return item ? item.value : '';
};
export var defaultSubtextGetter = function defaultSubtextGetter(item) {
  return item ? item.subtext : '';
};
//# sourceMappingURL=defaultGetters.js.map